import { useState, useEffect } from 'react';
import SelectInput from './SelectInput';
import { getFaculties } from "@services/facultyService"

const FacultySelectInput = ({ register, errors, name, validationRules = { required: 'Faculty is required' }, className='' }) => {
  const [facultyOptions, setFacultyOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaculties = async () => {
      try {
        let data = await getFaculties();
        setFacultyOptions(data.map(faculty => ({
          value: faculty.id,
          label: faculty.name
        })));
      } catch (error) {
        console.error('Error fetching faculties:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFaculties();
  }, []);

  if (loading) {
    return <p>Loading faculty...</p>;
  }

  return (
    <SelectInput
      label="Faculty"
      name={name}
      register={register}
      errors={errors}
      options={facultyOptions}
      validationRules={validationRules}
      className={className}
    />
  );
};

export default FacultySelectInput;
